<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<!-- h-full max-h-screen flex flex-col -->
		<form class="h-full flex flex-col">
			<div
				class="bg-green-500 text-white flex grid grid-cols-12 relative items-baseline"
			>
				<h1 class="p-4 text-4xl font-bold col-span-8 lg:col-span-9">
					{{ h1 }}
					<span v-if="isRenew">({{ __("Renewal") }})</span>
				</h1>

				<div class="p-4 text-white col-span-3 text-left">
					<h2 class="inline text-2xl font-bold" v-if="step == 1">
						<span v-if="showReference && !isRenew">{{
							trade == "SELL"
								? __("According to buy offer")
								: __("According to sell offer")
						}}</span>
						<span v-else-if="showReference && isRenew">{{
							trade == "BUY"
								? __("According to previous buy offer")
								: __("According to previous sell offer")
						}}</span>
						<span v-else>&nbsp;</span>
					</h2>
					<h2 class="inline text-2xl font-bold" v-else-if="step == 2">
						{{ __("Review") }}
					</h2>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<!-- extra row for a button to close the right column
            <div class="relative">
                <div class="grid grid-cols-12 w-full"
                    :class="!showReference || showReference ? 'absolute' : ''">

                    <div class="col-start-9 lg:col-start-10 col-span-4 lg:col-span-3 bg-gray-100 p-4" >
                        <ui-button
                            type="blank"
                            v-if="showReference == false"
                            v-on:click="showReference = true"
                            class="text-base text-left font-semibold text-orange-500"
                            :label="trade == 'SELL' ? 'Show buyer request' : 'Show seller request'"
                        />
                        <ui-button
                            type="blank"
                            v-if="showReference == true"
                            v-on:click="showReference = false"
                            class="text-base text-left font-semibold text-orange-500"
                            :label="trade == 'SELL' ? 'Hide buyer request' : 'Hide seller request'"
                        />
                    </div>
                </div>
            </div>-->

			<div class="overflow-y-auto">
				<bid-edit-step-1
					v-if="step == 1"
					:form="form"
					:counterpart="counterpart"
					:reference="reference"
					:match="match"
					:iframe-modal="iframeModal"
					:trade="trade"
					:active-futures="activeFutures"
					:other-errors="otherErrors"
					:show-reference="showReference"
					:user="user"
				/>

				<bid-edit-step-2
					v-if="step == 2"
					:form="form"
					:active-futures="activeFutures"
					:reference="reference"
					:match="match"
					:user="user"
					:trade="trade"
				/>

				<div class="bg-gray-100 p-6 flex justify-between">
					<div>
						<ui-button
							type="secondary"
							v-if="step == 2"
							v-on:click="step--"
							label="Back"
						/>
					</div>
					<div>
						<ui-button
							type="primary"
							v-if="step == 1"
							v-on:click="tryGotoStepIfFormValid(step + 1)"
							label="Continue"
						/>
						<ui-button
							v-else-if="step == 2"
							type="primary"
							:disabled="submitButtonDisabled"
							v-on:click="submitForm()"
							:label="buttonLabel"
						></ui-button>
					</div>
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		bid: {
			type: Object,
			required: true,
		},
		counterpart: {
			type: Object,
			required: true,
		},
		reference: {
			type: Object,
			required: true,
		},
		match: {
			type: Object,
			required: false,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		trade: {
			type: String,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		targetTypeCounter: {
			type: Boolean,
			required: false,
			default: false,
		},
		isRenew: {
			type: Boolean,
			required: false,
			default: false,
		},
		user: {
			type: Object,
			required: true,
		},
		lastDisplayedPrice: {
			type: Number,
			required: false,
		},
		priceIndication: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.bid)),
			step: 1,
			steps: [{ name: "Place Bid" }, { name: "Review" }],
			showReference: this.priceIndication ? false : true, // show ref unless user is responding to price indication
		};
	},
	computed: {
		h1() {
			let label = null,
				isCounter = this.targetTypeCounter;
			if (this.trade == "BUY") {
				label = isCounter
					? "Place counter-offer to seller"
					: "Your bid to seller";
			} else {
				label = isCounter
					? "Place counter-offer to buyer"
					: "Your bid to buyer";
			}
			return this.__(label);
		},
		buttonLabel() {
			let label = null,
				isCounter = this.targetTypeCounter;
			if (this.trade == "BUY") {
				label = isCounter ? "Place counter-offer to seller" : "Place buy offer";
			} else {
				label = isCounter ? "Place counter-offer to buyer" : "Place sell offer";
			}
			return this.__(label);
		},
	},
	methods: {
		onSuccess() {
			if (!this.isRenew && !this.targetTypeCounter) {
				console.log("ANALYTICS_EMIT_BID_SUBMITTED");
				this.$bus.$emit("analytics:created-bid");
			}
		},
	},
};
</script>
